import { styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const Title = styled(Typography)`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.palette.primary.main};
  @media (max-width: 1023px) {
    display: none;
    margin-bottom: 16px;
  }
`;

export const ListW = styled('div')`
  width: 336px;
  position: relative;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const TaskListW = styled('div')<{ isProfile?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-bottom: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  gap: 8px;

  @media (min-width: 1024px) {
    ${({ isProfile }) => isProfile && 'height: 580px;'}
  }

  @media (max-width: 1023px) {
    overflow: hidden;
  }
`;

export const MoreLink = styled(NavLink)`
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
  text-align: right;

  &:hover {
    text-decoration: underline;
  }
`;
